import React, { useState } from "react";
import useAuth from "../Auth/useAuth";
import { Navigate, useLocation } from "react-router-dom";
import { collection, addDoc, setDoc, doc } from "firebase/firestore";
import { auth, db } from "../firebase";
import { Link } from "react-router-dom";
import { async } from "@firebase/util";
import { createUserWithEmailAndPassword } from "firebase/auth";


const RegisterPage = () => {
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [studentIdNumber, setStudentIdNumber] = useState("");

  const { user, loading } = useAuth();

  const registerStudent = async () => {
    if (!email) return alert("Email can't be empty!");
    if (!password) return alert("Password can't be empty!");
    if (password?.length < 6)
      return alert("Password must be of minimum 6 charecters!");
    if (password !== confirmPassword) return alert("Password missmatched!");

    createUserWithEmailAndPassword(auth, email, password)
      .then(async (userCradientials) => {
        const user = userCradientials.user;

        await setDoc(doc(db, "studentUserTypeVerify", user?.uid),{
          email: user?.email,
          userType: "awaiting",
          designation: "awaiting",
          status: "Not Verified",
          studentIdNumber : studentIdNumber
        });
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  if (user) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <React.Fragment>
      <header className="text-[#ffffff] lg:bg-[#1da1f2]">
        <div className="relative lg:py-5 bg-[#ffffff] ">
          <div className="grid grid-cols-7 text-center">
            <div className="lg:pl-20 md:pl-20 hidden md:block lg:block ">
              <img src="./assets/as_logo.png" alt="pic" className="h-32 w-32" />
            </div>

            <div className="flex flex-wrap flex-col lg:col-span-5 md:col-span-5 col-span-7 ">
              <h1 className="lg:text-5xl md:text-5xl text-2xl text-black font-bold text-center ">
                Bokaro Ispat Senior Secondary School-8B
              </h1>
              <div className="lg:flex justify-center">
                <h1 className=" lg:text-2xl md:text-2xl text-base text-center  mt-1 font-bold  text-black ">
                  NEAR SURYA MANDIR BOKARO STEEL CITY,
                </h1>
                <span className="ml-5 text-base mt-3 uppercase text-center font-semibold text-black">
                  CBSE Affiliation NO. :- 3430077
                </span>
              </div>
              <h1 className="text-center font-semibold text-black lg:text-xl text-sm">
                BOKARO JHARKHAND-827009
              </h1>
            </div>
            <div className="hidden md:block lg:block ">
              <img src="./assets/sail.png" alt="pic" className="h-32 w-32" />
            </div>
          </div>
        </div>
        <div className="bg-blue-900">
          <nav className="flex-col flex-grow h-10 hidden md:pb-0 md:flex md:justify-start md:flex-row">
            <ul className="flex lg:ml-32">
              <Link to={"/home"}>
                <li className="mx-1 lg:px-1 py-2 group lg:mr-6 text-white  mb-1 md:mb-0">
                  <span className="font-semibold hover:bg-[#2931B7]">Home</span>
                </li>
              </Link>
              <li className="mx-1 lg:px-1 py-2 group lg:mr-6 text-white  mb-1 md:mb-0">
                <span className="font-semibold hover:bg-[#2931B7]">
                  Guidelines
                </span>
              </li>
              <li className="mx-1 lg:px-1 py-2 group lg:mr-6 text-white  mb-1 md:mb-0">
                <span className="font-semibold hover:bg-[#2931B7]">
                  Instruction and Procedure
                </span>
              </li>
            </ul>
          </nav>
        </div>
      </header>

      <div className="flex justify-center">
        <div className="mx-4 w-96 px-4 py-10 pt-4 rounded-xl space-y-4 mt-20 mb-10 bg-white shadow-lg border shadow-gray-500">
          <div className="text-indigo-400 pt-2 ">
            <h1 className="text-4xl font-bold">Register here!</h1>
            <div className="border-b-4 mt-4"></div>
          </div>
          <div className="rounded-lg p-2 ">
            <h2 className="">Register ID</h2>
            <input
              type="text"
              value={studentIdNumber}
              onChange={(e) => {
                setStudentIdNumber(e.target.value);
              }}
              className="px-3 py-2 border border-[#1e3a8a] text-center w-full bg-white rounded-md"
              placeholder="Enter Register ID"
            />
          </div>
          <div className="rounded-lg p-2 ">
            <h2 className="">Email ID</h2>
            <input
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              className="px-3 py-2 border border-[#1e3a8a] text-center w-full bg-white rounded-md"
              placeholder="Enter Email ID"
            />
          </div>
          <div className="rounded-lg p-2">
            <h2 className="">Password</h2>
            <input
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
              className="px-3 py-2 border border-[#1e3a8a] text-center w-full bg-white rounded-md"
              placeholder="Password"
            />
          </div>
          <div className="rounded-lg p-2">
            <h2 className="">Confirm Password</h2>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => {
                setConfirmPassword(e.target.value);
              }}
              className="px-3 py-2 border border-[#1e3a8a] text-center w-full bg-white rounded-md"
              placeholder="Confirm Password"
            />
          </div>

          <div className="w-full text-center">
            {!loading ? (
              <button
                className="mt-5 border-2 my-4  px-8 py-2 bg-white border-[#1e3a8a] rounded-lg  text-black font-semibold hover:scale-110 ease-in-out duration-700 hover:bg-[#1e3a8a] hover:border-[#ffffff] hover:text-white"
                onClick={registerStudent}
              >
                Submit
              </button>
            ) : (
              <div className="mt-5 flex justify-center">
                <img
                  className="w-12 h-10"
                  src="../assets/loadingSpinner1.gif"
                  alt=""
                />
              </div>
            )}
            <div className="flex mx-4 pt-2 pb-2 text-center justify-center">
              <span className="mx-2">already have an account?</span>
              <Link to={"/login"}>
                <span className="text-[#2931B7] hover:text-black underline underline-offset-1">
                  login
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <footer className="border-t-2">
        <div className="text-center font-bold p-6 bg-white">
          <span className="text-black">© 2022 - </span>
          <span className="text-black text-lg font-bold hover:text-blue-300 ">
            BISSS-8B
          </span>
          <span className="text-black">
            , Education Department, Bokaro Steel Plant
          </span>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default RegisterPage;
